import { FC } from "react";
import { InfoBadge } from "@app/shared/InfoBadge";
import { QESWidget, QESWidgetContent } from "@app/shared/widget";
import { SelectedNetwork } from "@app/compliance-connect/regulator/complianceConnectTypes";

interface SelectedNetworksWidgetProps {
    networks: SelectedNetwork[];
}

const SelectedNetworksWidget: FC<SelectedNetworksWidgetProps> = ({ networks }) => (
    <div data-testid="compliance-connect__selected-networks-widget">
        <QESWidget className="w-100" size="small">
            <QESWidgetContent>
                <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                    <span className="copy-text-default text-nowrap demibold">Selected Networks:</span>
                    <div className="d-flex flex-wrap" style={{ gap: "0.5rem" }}>
                        {networks.map((n) => (
                            <InfoBadge
                                key={n.networkId}
                                content={<span className="label-tiny">{n.networkName}</span>}
                                icon={null}
                                testId={`compliance-connect__selected-network-pill-${n.networkId}`}
                            />
                        ))}
                    </div>
                </div>
            </QESWidgetContent>
        </QESWidget>
    </div>
);

export default SelectedNetworksWidget;
